module.exports = __webpack_public_path__ + "img/a1-3.73f6b0dd.png";